'use client'

import { createContextWithProvider } from '@qr-front/ui/utils/context'

export const [IsPreviewModeContext, IsPreviewModeProvider] =
	createContextWithProvider<boolean>('IsPreviewModeContext')
